import { FunctionComponent } from 'react'

import { Grid, Box, Tooltip, Button } from '@material-ui/core'

import Card from 'shared/components/Card'
import Formatter from 'shared/utils/formatters'

import { ItemContainer, Subtitle, Title, GridCard } from './styles'
import IViagemPedagioDTO from 'modules/valePedagio/domain/entities/IViagemPedagioDTO'
import {
  getStatusViagemPedagioFormatado,
  isStatusHabilitaVerDetalhes,
} from 'modules/valePedagio/domain/entities/EStatusPedagioViagem'
import { colors } from 'shared/styles/colors'

type TProp = {
  viagem: IViagemPedagioDTO
  onClick: () => void
}

const ViagemCard: FunctionComponent<TProp> = ({ viagem, onClick }) => {
  const MAX_STRING = 26

  const renderSubtitle = subtitle => {
    if (subtitle?.length > MAX_STRING) {
      return (
        <Tooltip
          placement="top"
          title={Formatter.textoCapitular(subtitle)}
          arrow
        >
          <Subtitle>{subtitle.substring(0, MAX_STRING)}...</Subtitle>
        </Tooltip>
      )
    }

    return <Subtitle>{subtitle}</Subtitle>
  }

  return (
    <GridCard>
      <Card className={`card-height card-lote-${viagem.id}`}>
        <Grid container direction={'column'}>
          <ItemContainer>
            <Box display={'flex'} flexDirection={'column'}>
              {renderSubtitle(getStatusViagemPedagioFormatado(viagem.status))}
              <Title>Placa {viagem.placa}</Title>
            </Box>
          </ItemContainer>
          <hr style={{ marginBottom: 16, color: colors.stepInactive }} />
          <Grid container direction={'row'}>
            <ItemContainer>
              <Box display={'flex'} flexDirection={'column'}>
                <Title>Origem</Title>
                {renderSubtitle(viagem?.origem ?? '')}
              </Box>
            </ItemContainer>
          </Grid>

          <Grid container direction={'row'}>
            <ItemContainer>
              <Box display={'flex'} flexDirection={'column'}>
                <Title>Destino</Title>
                {renderSubtitle(viagem?.destino ?? '')}
              </Box>
            </ItemContainer>
          </Grid>
          {isStatusHabilitaVerDetalhes(viagem.status) && (
            <Button
              fullWidth
              className="card-button card-button-mt"
              type="submit"
              onClick={onClick}
            >
              Ver detalhes
            </Button>
          )}
        </Grid>
      </Card>
    </GridCard>
  )
}

export default ViagemCard
